"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingSelectInput = exports.SelectInput = exports.sortByLabel = exports.stringsToOptions = void 0;
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var theme_1 = require("../../theme");
var spinner_1 = require("../spinner");
var simple_select_input_1 = (0, tslib_1.__importDefault)(require("./components/simple-select-input"));
exports.SelectInput = simple_select_input_1.default;
function stringsToOptions(strings) {
    return strings.map(function (str) { return ({ label: str, value: str }); });
}
exports.stringsToOptions = stringsToOptions;
function sortByLabel(a, b) {
    if (a.label < b.label) {
        return -1;
    }
    if (a.label > b.label) {
        return 1;
    }
    return 0;
}
exports.sortByLabel = sortByLabel;
var LoadingSelectInput = function () { return (React.createElement(StyledLoadingSelectInput, null,
    React.createElement(spinner_1.Spinner, { color: theme_1.colors.gray_l }))); };
exports.LoadingSelectInput = LoadingSelectInput;
var StyledLoadingSelectInput = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  background: #fafafa;\n  border: 1px solid ", ";\n  border-radius: 3px;\n  cursor: wait;\n  height: 38px;\n  position: relative;\n"], ["\n  background: #fafafa;\n  border: 1px solid ", ";\n  border-radius: 3px;\n  cursor: wait;\n  height: 38px;\n  position: relative;\n"])), theme_1.colors.gray_xl);
var templateObject_1;
//# sourceMappingURL=index.js.map